import { createContext, useContext } from 'react';

export interface SidebarContextType {
    isDesktopNavigationExpanded: boolean;
    setIsDesktopNavigationExpanded: (value: boolean) => void;
    isMobileNavigationExpanded: boolean;
    setIsMobileNavigationExpanded: (value: boolean) => void;

    isNavigationExpanded: boolean;
    isNavigationFullyExpanded: boolean;
    isNavigationFullyCollapsed: boolean;

    setIsNavigationExpanded: (value: boolean) => void;
    toggleNavigationExpanded: () => void;
}

export const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export function useSidebarContext() {
    const context = useContext(SidebarContext);

    if (!context) {
        throw new Error('useSidebarContext must be used within a SidebarProvider');
    }

    return context;
}
